import { Button, Group, Text } from "@mantine/core";
import { ConfirmAndExecutePanel, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { SolicitudesRuteo } from "./SolicitudesRuteo";

export const ACTEliminarRuta: EntityClientAction = {
    name: 'ACTEliminarRuta',
    label: 'Eliminar Ruta',
    title: <Text fw={700}>Eliminar ruta</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    views: ['soru_brwDisponibleEnRutas'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const abort_controller = new AbortController();

        await modal.open({
            modalProps: {
                title: <Text fw="700">Solicitud de eliminación de ruta</Text>
            },
            focusOnClosed: element,
            content: <ConfirmAndExecutePanel
                content={<Text size="sm" mb="xs">Va a generar una solicitud de eliminación de ruta. ¿Está seguro?</Text>}
                operation="proc"
                onCancel={async () => {
                    abort_controller.abort();
                    await modal.close();
                    if (onClose) await onClose(false);
                }}
                onOK={
                    async () => {
                        // cast entity
                        const solicitudesRuteo = new SolicitudesRuteo(entity.API.client);
                        solicitudesRuteo.def.columns.c_personal_id.value = selectedKeys![0].c_personal_id as unknown as string || '';
                        solicitudesRuteo.def.columns.c_tiposolicitudruta_id.value = 'ELIMINAR';
                        const result = await solicitudesRuteo.API.addData();

                        if (result.Failed) {
                            await modal.open({
                                modalProps: {
                                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                                },
                                focusOnClosed: element,
                                content:
                                    <>
                                        <Text size="sm" mb="xs">
                                            {result.Results[0].Message}
                                        </Text>
                                        <Group mt="xs" position="right">
                                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                                        </Group>
                                    </>
                            });
                        }

                        if (onClose) await onClose();
                        await modal.close();
                    }
                }
            />

        });

        return false;
    }
}